var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"WorldBabylon",on:{"click":function($event){_vm.toogle = !_vm.toogle}}},[_c('canvas',{ref:"canvas",class:{ over: _vm.toogle },attrs:{"id":"renderCanvas"}})])}
var staticRenderFns = []

export { render, staticRenderFns }